<template>
  <div class="bg-white rounded-xl shadow-sm p-6 sticky top-6">
    <!-- Search Input -->
    <div class="mb-6">
      <label class="block text-sm font-semibold text-gray-700 mb-2">Zoeken</label>
      <input
        :value="filters.searchQuery"
        @input="updateFilter('searchQuery', $event.target.value)"
        type="text"
        placeholder="Zoek naar product..."
        class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-theme focus:border-transparent"
      />
    </div>

    <!-- Filter Categories -->
    <div class="space-y-4">
      <!-- Agro Section -->
      <div>
        <h3 class="text-sm font-bold text-gray-900 mb-2 uppercase tracking-wide">Agro</h3>
        <div class="space-y-3 pl-2">
          <!-- Kalverhouderij -->
          <div v-if="getSubcategoryItems('agro', 'kalverhouderij').length > 0">
            <h4 class="text-xs font-semibold text-gray-600 mb-1">Kalverhouderij</h4>
            <div class="space-y-1 pl-3">
              <label v-for="item in getSubcategoryItems('agro', 'kalverhouderij')" :key="item.value" class="flex items-center cursor-pointer group">
                <input
                  :checked="filters.selectedCategories.includes(item.value)"
                  @change="toggleArrayFilter('selectedCategories', item.value)"
                  type="checkbox"
                  class="h-4 w-4 text-theme focus:ring-theme border-gray-300 rounded"
                />
                <span class="ml-3 text-sm text-gray-700 group-hover:text-gray-900">{{ item.label }}</span>
              </label>
            </div>
          </div>

          <!-- Rundveehouderij -->
          <div v-if="getSubcategoryItems('agro', 'rundveehouderij').length > 0">
            <h4 class="text-xs font-semibold text-gray-600 mb-1">Rundveehouderij</h4>
            <div class="space-y-1 pl-3">
              <label v-for="item in getSubcategoryItems('agro', 'rundveehouderij')" :key="item.value" class="flex items-center cursor-pointer group">
                <input
                  :checked="filters.selectedCategories.includes(item.value)"
                  @change="toggleArrayFilter('selectedCategories', item.value)"
                  type="checkbox"
                  class="h-4 w-4 text-theme focus:ring-theme border-gray-300 rounded"
                />
                <span class="ml-3 text-sm text-gray-700 group-hover:text-gray-900">{{ item.label }}</span>
              </label>
            </div>
          </div>

          <!-- Varkenshouderij -->
          <div v-if="getSubcategoryItems('agro', 'varkenshouderij').length > 0">
            <h4 class="text-xs font-semibold text-gray-600 mb-1">Varkenshouderij</h4>
            <div class="space-y-1 pl-3">
              <label v-for="item in getSubcategoryItems('agro', 'varkenshouderij')" :key="item.value" class="flex items-center cursor-pointer group">
                <input
                  :checked="filters.selectedCategories.includes(item.value)"
                  @change="toggleArrayFilter('selectedCategories', item.value)"
                  type="checkbox"
                  class="h-4 w-4 text-theme focus:ring-theme border-gray-300 rounded"
                />
                <span class="ml-3 text-sm text-gray-700 group-hover:text-gray-900">{{ item.label }}</span>
              </label>
            </div>
          </div>

          <!-- Voedselbewaring -->
          <div v-if="getSubcategoryItems('agro', 'voedselbewaring').length > 0">
            <h4 class="text-xs font-semibold text-gray-600 mb-1">Voedselbewaring</h4>
            <div class="space-y-1 pl-3">
              <label v-for="item in getSubcategoryItems('agro', 'voedselbewaring')" :key="item.value" class="flex items-center cursor-pointer group">
                <input
                  :checked="filters.selectedCategories.includes(item.value)"
                  @change="toggleArrayFilter('selectedCategories', item.value)"
                  type="checkbox"
                  class="h-4 w-4 text-theme focus:ring-theme border-gray-300 rounded"
                />
                <span class="ml-3 text-sm text-gray-700 group-hover:text-gray-900">{{ item.label }}</span>
              </label>
            </div>
          </div>
        </div>
      </div>

      <!-- Infra Section -->
      <div>
        <h3 class="text-sm font-bold text-gray-900 mb-2 uppercase tracking-wide">Infra</h3>
        <div class="space-y-3 pl-2">
          <!-- Antislip Vloerplaten -->
          <div v-if="getSubcategoryItems('infra', 'antislip vloerplaten').length > 0">
            <h4 class="text-xs font-semibold text-gray-600 mb-1">Antislip Vloerplaten</h4>
            <div class="space-y-1 pl-3">
              <label v-for="item in getSubcategoryItems('infra', 'antislip vloerplaten')" :key="item.value" class="flex items-center cursor-pointer group">
                <input
                  :checked="filters.selectedCategories.includes(item.value)"
                  @change="toggleArrayFilter('selectedCategories', item.value)"
                  type="checkbox"
                  class="h-4 w-4 text-theme focus:ring-theme border-gray-300 rounded"
                />
                <span class="ml-3 text-sm text-gray-700 group-hover:text-gray-900">{{ item.label }}</span>
              </label>
            </div>
          </div>

          <!-- HYDRO-Green -->
          <div v-if="getSubcategoryItems('infra', 'hydro-green').length > 0">
            <h4 class="text-xs font-semibold text-gray-600 mb-1">HYDRO-Green</h4>
            <div class="space-y-1 pl-3">
              <label v-for="item in getSubcategoryItems('infra', 'hydro-green')" :key="item.value" class="flex items-center cursor-pointer group">
                <input
                  :checked="filters.selectedCategories.includes(item.value)"
                  @change="toggleArrayFilter('selectedCategories', item.value)"
                  type="checkbox"
                  class="h-4 w-4 text-theme focus:ring-theme border-gray-300 rounded"
                />
                <span class="ml-3 text-sm text-gray-700 group-hover:text-gray-900">{{ item.label }}</span>
              </label>
            </div>
          </div>

          <!-- HYDRO-Mark -->
          <div v-if="getSubcategoryItems('infra', 'hydro-mark').length > 0">
            <h4 class="text-xs font-semibold text-gray-600 mb-1">HYDRO-Mark</h4>
            <div class="space-y-1 pl-3">
              <label v-for="item in getSubcategoryItems('infra', 'hydro-mark')" :key="item.value" class="flex items-center cursor-pointer group">
                <input
                  :checked="filters.selectedCategories.includes(item.value)"
                  @change="toggleArrayFilter('selectedCategories', item.value)"
                  type="checkbox"
                  class="h-4 w-4 text-theme focus:ring-theme border-gray-300 rounded"
                />
                <span class="ml-3 text-sm text-gray-700 group-hover:text-gray-900">{{ item.label }}</span>
              </label>
            </div>
          </div>

          <!-- HYDRO-Park -->
          <div v-if="getSubcategoryItems('infra', 'hydro-park').length > 0">
            <h4 class="text-xs font-semibold text-gray-600 mb-1">HYDRO-Park</h4>
            <div class="space-y-1 pl-3">
              <label v-for="item in getSubcategoryItems('infra', 'hydro-park')" :key="item.value" class="flex items-center cursor-pointer group">
                <input
                  :checked="filters.selectedCategories.includes(item.value)"
                  @change="toggleArrayFilter('selectedCategories', item.value)"
                  type="checkbox"
                  class="h-4 w-4 text-theme focus:ring-theme border-gray-300 rounded"
                />
                <span class="ml-3 text-sm text-gray-700 group-hover:text-gray-900">{{ item.label }}</span>
              </label>
            </div>
          </div>

          <!-- HYDRO-Road -->
          <div v-if="getSubcategoryItems('infra', 'hydro-road').length > 0">
            <h4 class="text-xs font-semibold text-gray-600 mb-1">HYDRO-Road</h4>
            <div class="space-y-1 pl-3">
              <label v-for="item in getSubcategoryItems('infra', 'hydro-road')" :key="item.value" class="flex items-center cursor-pointer group">
                <input
                  :checked="filters.selectedCategories.includes(item.value)"
                  @change="toggleArrayFilter('selectedCategories', item.value)"
                  type="checkbox"
                  class="h-4 w-4 text-theme focus:ring-theme border-gray-300 rounded"
                />
                <span class="ml-3 text-sm text-gray-700 group-hover:text-gray-900">{{ item.label }}</span>
              </label>
            </div>
          </div>

          <!-- HYDRO-Storage -->
          <div v-if="getSubcategoryItems('infra', 'hydro-storage').length > 0">
            <h4 class="text-xs font-semibold text-gray-600 mb-1">HYDRO-Storage</h4>
            <div class="space-y-1 pl-3">
              <label v-for="item in getSubcategoryItems('infra', 'hydro-storage')" :key="item.value" class="flex items-center cursor-pointer group">
                <input
                  :checked="filters.selectedCategories.includes(item.value)"
                  @change="toggleArrayFilter('selectedCategories', item.value)"
                  type="checkbox"
                  class="h-4 w-4 text-theme focus:ring-theme border-gray-300 rounded"
                />
                <span class="ml-3 text-sm text-gray-700 group-hover:text-gray-900">{{ item.label }}</span>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Active Filters Display -->
    <div v-if="activeFiltersCount > 0" class="mb-6 mt-4 p-4 bg-theme-light rounded-lg border border-theme-border">
      <h4 class="text-sm font-semibold text-theme mb-3">Actieve filters ({{ activeFiltersCount }})</h4>
      <div class="flex flex-wrap gap-2">
        <span v-if="filters.searchQuery" class="inline-flex items-center text-xs bg-theme-bg text-white px-3 py-1 rounded-full">
          "{{ filters.searchQuery }}"
          <button @click="updateFilter('searchQuery', '')" class="ml-2 text-white hover:text-theme-hover font-bold">&times;</button>
        </span>
        <span
          v-for="category in filters.selectedCategories"
          :key="category"
          class="inline-flex items-center text-xs bg-theme-bg text-white px-3 py-1 rounded-full"
        >
          {{ getCategoryLabel(category) }}
          <button @click="toggleArrayFilter('selectedCategories', category)" class="ml-2 text-white hover:text-theme-hover font-bold">&times;</button>
        </span>
      </div>
    </div>

    <!-- Clear Filters Button -->
    <button
      @click="clearAllFilters"
      class="w-full px-6 py-3 mt-4 text-sm font-semibold text-theme bg-theme-light border border-theme-border rounded-lg hover:bg-theme-bg transition-colors"
      :disabled="activeFiltersCount === 0"
      :class="{ 'opacity-50 cursor-not-allowed': activeFiltersCount === 0 }"
    >
      Alle filters wissen
    </button>
  </div>
</template>

<script>
export default {
  name: 'FilterSidebar',
  props: {
    filters: {
      type: Object,
      required: true
    },
    vacations: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      // Anders Beton category structure: Category > Subcategory > Products
      categoryStructure: {
        agro: {
          kalverhouderij: [
            'balken',
            'puro-vloer',
            'vloerplaten voor kalverstallen'
          ],
          rundveehouderij: [
            'boxdekken',
            'eco-vloeren',
            'eindwanden en randen',
            'geprofileerde rundveeroosters',
            'melkrobotplaten',
            'onderslagbalken & mixput deksels',
            'opstortvloeren',
            'prefab aslastplaten',
            'rundveeroosters'
          ],
          varkenshouderij: [
            'balken voor varkensstallen',
            'porco-roosters',
            'prefab vloerplaten voor varkensstallen',
            'varkensroosters',
            'vloerplaten voor varkensstallen'
          ],
          voedselbewaring: [
            'aero-roosters',
            'prefab ventilatorvloer'
          ]
        },
        infra: {
          'antislip vloerplaten': [
            'verhardingsplaten'
          ],
          'hydro-green': [
            'hydro-platen'
          ],
          'hydro-mark': [
            'hydro-platen'
          ],
          'hydro-park': [
            'hydro-platen'
          ],
          'hydro-road': [
            'hydro-sideroad'
          ],
          'hydro-storage': [
            'hydro-platen'
          ]
        }
      },

      // Labels for display
      labelMappings: {
        // Agro - Kalverhouderij
        'balken': 'Balken',
        'puro-vloer': 'PURO-Vloer',
        'vloerplaten voor kalverstallen': 'Vloerplaten voor Kalverstallen',
        // Agro - Rundveehouderij
        'boxdekken': 'Boxdekken',
        'eco-vloeren': 'ECO-Vloeren',
        'eindwanden en randen': 'Eindwanden en Randen',
        'geprofileerde rundveeroosters': 'Geprofileerde Rundveeroosters',
        'melkrobotplaten': 'Melkrobotplaten',
        'onderslagbalken & mixput deksels': 'Onderslagbalken & Mixput Deksels',
        'opstortvloeren': 'Opstortvloeren',
        'prefab aslastplaten': 'Prefab Aslastplaten',
        'rundveeroosters': 'Rundveeroosters',
        // Agro - Varkenshouderij
        'balken voor varkensstallen': 'Balken voor Varkensstallen',
        'porco-roosters': 'PORCO-Roosters',
        'prefab vloerplaten voor varkensstallen': 'Prefab Vloerplaten voor Varkensstallen',
        'varkensroosters': 'Varkensroosters',
        'vloerplaten voor varkensstallen': 'Vloerplaten voor Varkensstallen',
        // Agro - Voedselbewaring
        'aero-roosters': 'AERO-Roosters',
        'prefab ventilatorvloer': 'Prefab Ventilatorvloer',
        // Infra - Antislip Vloerplaten
        'verhardingsplaten': 'Verhardingsplaten',
        // Infra - HYDRO
        'hydro-platen': 'HYDRO-Platen',
        'hydro-sideroad': 'HYDRO-Sideroad'
      },

      // Categories to exclude from filtering
      excludeFromFilters: ['producten', 'assortiment']
    }
  },

  computed: {
    // Extract all unique categories from product data
    allCategories() {
      const categories = new Set()
      const hideLabels = this.$root.shopSettings?.hideLabels || []

      this.vacations.forEach(vacation => {
        if (vacation.metadata && vacation.metadata.categories) {
          vacation.metadata.categories.forEach(category => {
            const lowerCategory = category.toLowerCase()
            if (!hideLabels.includes(lowerCategory) &&
                !this.excludeFromFilters.includes(lowerCategory)) {
              categories.add(lowerCategory)
            }
          })
        }
      })
      return Array.from(categories)
    },

    activeFiltersCount() {
      let count = 0
      if (this.filters.searchQuery) count++
      count += this.filters.selectedCategories?.length || 0
      return count
    }
  },

  methods: {
    getSubcategoryItems(category, subcategory) {
      const products = this.categoryStructure[category]?.[subcategory] || []
      return products
        .filter(product => {
          return this.allCategories.includes(product) ||
                 this.allCategories.some(c => c.includes(product)) ||
                 // Also match subcategory name itself
                 this.allCategories.includes(subcategory)
        })
        .map(product => ({
          value: product,
          label: this.labelMappings[product] || this.formatLabel(product)
        }))
    },

    updateFilter(filterName, value) {
      this.$emit('filter-change', { [filterName]: value })
    },

    toggleArrayFilter(filterName, value) {
      const currentArray = [...(this.filters[filterName] || [])]
      const index = currentArray.indexOf(value)

      if (index > -1) {
        currentArray.splice(index, 1)
      } else {
        currentArray.push(value)
      }

      this.updateFilter(filterName, currentArray)
    },

    clearAllFilters() {
      this.$emit('clear-filters')
    },

    formatLabel(value) {
      return value
        .split(/[-_\s]+/)
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ')
    },

    getCategoryLabel(value) {
      return this.labelMappings[value] || this.formatLabel(value)
    }
  }
}
</script>

<style>
.text-theme {
  color: var(--theme);
}

.text-theme-hover {
  color: var(--theme-hover);
}

.bg-theme-light {
  background-color: var(--theme-light);
}

.bg-theme-bg {
  background-color: var(--theme);
}

.border-theme-border {
  border-color: var(--theme-border);
}

.focus\:ring-theme:focus {
  --tw-ring-color: var(--theme);
}
select {
  background: unset !important;
}
</style>
